
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./oneProductPage.css";
import { observer } from "mobx-react-lite";
import { Context } from "../../../index";
import { Link, useNavigate, useParams } from "react-router-dom";

import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import {
    getCategories,
    getDataForBreadcrumbs,
    getProduct,
    mindboxViewProduct,
    mindboxAddProductToProsmotrennyeItemList,
    getSliderData,
    getLastViewed
} from "../../../http/catalogApi";
import { phoneCountryArr } from "../../../utils/consts";
import Spiner from "../../administrator/spiner/Spiner";
import ProductBreadcrumbs from "./productBreadcrumbs/ProductBreadcrumbs";
import Like from "../../../components/UI/Like/Like";
import { priceToUserString } from "../../../http/basketApi";
import { createPreOrder, сreateSertificateOrder } from "../../../http/orderApi";
import CheckBoxPolitic from "../../../components/UI/checkBoxPolitic/CheckBoxPolitic";
import { useLocation } from "react-router";
import ConfirmedPreorderQuoteForm, {pendingConfirmedPreorderKey} from "./ConfirmedPreorderQuoteForm";
import OfferSliderProduct from "./OfferSliderProduct";
import { pushGoogleAnalyticProductAction } from "../../../utils/googleAnalytic";
import InputMask from "react-input-mask";
import NotFound from "../../content/notFound/NotFound";
import { getCommonContent } from "../../../http/contentApi";
import OptionCountry from "../../../components/header/MainHeaderLine/IconsBar/modalAuth/RegistrationForm/OptionCountry";
import FastOrderPopup from "./fastOrderPopup";
import Modal from "../../../components/Modal/Modal";
import SwiperCore, { Navigation } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
import mindBox from "../../../analytics/mindBox";
import { getSizeCommerceView, isOrdinarySizeAvailable, parseWarehouseStocks, usesEnforcedCommerce } from "../../../utils/onecStockAvailability";
import {canDraftPreorder} from '../../../store/PreorderCartStore';

SwiperCore.use([Navigation]);

// Whitelisted page content remains JSON-encoded for legacy compatibility. A
// broken/oversized optional content field must not break the commerce card.
const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
function readDisplayRows(raw, maxRows = 500) {
    let value = raw;
    for (let attempt = 0; attempt < 2 && typeof value === 'string'; attempt += 1) {
        if (value.length > 102400) return [];
        try {value = JSON.parse(value);} catch {return [];}
    }
    if (!Array.isArray(value) || value.length > maxRows) return [];
    for (let index = 0; index < value.length; index += 1) {
        if (!Object.prototype.hasOwnProperty.call(value, index) || !isRecord(value[index])) return [];
    }
    return value;
}
const validPublicSku = value => isRecord(value) && value.schemaVersion === 'public-sku-v1' &&
    ['enforced', 'shadow'].includes(value.mode) && typeof value.evaluatedAt === 'string' &&
    Number.isFinite(Date.parse(value.evaluatedAt)) && new Date(Date.parse(value.evaluatedAt)).toISOString() === value.evaluatedAt;
const displayText = value => typeof value === 'string' && value.length <= 2048 ? value : '';
const readTextContentRows = (raw, kind) => readDisplayRows(raw).map(row => kind === 'sostav'
    ? {name_sost: displayText(row.name_sost), fields: readDisplayRows(row.fields).map(field =>
        ({value: displayText(field.value)}))}
    : {size_name_obmer: displayText(row.size_name_obmer),
        position: (typeof row.position === 'number' || typeof row.position === 'string' && row.position.trim()) &&
            Number.isFinite(Number(row.position)) ? Number(row.position) : 0,
        fields: readDisplayRows(row.fields).map(field => ({name: displayText(field.name), value: displayText(field.value)}))});
function safeRetailMapUrl(value) {
    try {
        const url = new URL(value);
        return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : null;
    } catch {return null;}
}
function buildInformationalRetailTable(child) {
    const retail = child?.retailAvailability;
    if (!isRecord(retail) || retail.informational !== true) return false;
    const sizes = readDisplayRows(retail.sizes, 100);
    const stores = readDisplayRows(retail.stores, 500);
    if (!sizes.length) return false;
    const ids = new Set(), names = new Set();
    for (const size of sizes) {
        const selected = getSizeCommerceView(child, size.sizeName).descriptor;
        if (!Number.isSafeInteger(size.sizeId) || size.sizeId <= 0 || !selected || selected.sizeId !== size.sizeId ||
            selected.sizeName !== size.sizeName || ids.has(size.sizeId) || names.has(size.sizeName)) return false;
        ids.add(size.sizeId); names.add(size.sizeName);
    }
    const table = [['Магазины', ...sizes.map(size => size.sizeName)]];
    const storeIds = new Set();
    for (const store of stores) {
        const states = readDisplayRows(store.sizes, 100);
        if (!Number.isSafeInteger(store.marketId) || store.marketId <= 0 || storeIds.has(store.marketId) ||
            states.length !== sizes.length) return false;
        storeIds.add(store.marketId);
        const quantities = [];
        for (const size of sizes) {
            const matching = states.filter(row => row.sizeId === size.sizeId);
            if (matching.length !== 1 || !['available', 'unavailable', 'unknown'].includes(matching[0].state)) return false;
            quantities.push(matching[0].state === 'unknown' ? null : matching[0].state === 'available');
        }
        const phone = typeof store.phone === 'string' && /\d/.test(store.phone) && /^[+\d()\s-]{3,128}$/.test(store.phone) ? store.phone : '';
        table.push([{stock: {name: displayText(store.warehouseName), market: {
            city_name: displayText(store.cityName), name_market: displayText(store.name),
            address: displayText(store.address), work_schedule: displayText(store.workSchedule),
            front_number: phone, map_url: safeRetailMapUrl(store.mapUrl),
        }}}, ...quantities]);
    }
    return table.length > 1 ? table : false;
}

const OneProductPage = observer((props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { settings, user, basket, lastViewedStore } = useContext(Context)

    const params = useParams();
    const Navigate = useNavigate();

    const apiUrlWithoutSlash = process.env.REACT_APP_API_URL.slice(0, -1);
    const parrent = params.parrentCategory;
    const child = params.childCategory;
    const third = params.thirdCategory;
    const fourth = params.fourthCategory;
    const code = params.code;
    const [oneProduct, setOneProduct] = useState(null);
    const [parent, setParent] = useState(null);
    const [activeChild, setActiveChild] = useState(null);
    const [breadcrumbsParams, setBreadcrumbsparams] = useState(null);
    const [goRender, setGoRender] = useState(false);
    const [activeSizeChildProduct, setActiveSizeChildProduct] = useState("");
    const [commerceClock, setCommerceClock] = useState(0);
    const [commerceRefreshRetry, setCommerceRefreshRetry] = useState(0);
    const commerceRefreshAttempt = useRef({key: '', at: 0});
    const sizeBeforeCommerceRefresh = useRef(null);
    const [productProps, setProductProps] = useState({
        title: "",
        description: "",
    });
    const [notFound, setNotFound] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const enforcedResponseSeen = useRef(false);
    const [showOneClickButton, setShowOneClickButton] = useState(false);
    const [deviceUUID, setDeviceUUID] = useState("");
    const [userAgent, setUserAgent] = useState("");
    const [maskState, setMaskState] = useState(phoneCountryArr[0]);
    const [searchStateShow, setSearchStateShow] = useState("unactive");
    const [searchQuery, setSearchQuery] = useState("");
    const [lastViewed, setLastViewed] = useState([]);
    const [widget, setWidget] = useState(null);
    const [widgetImg, setWidgetImg] = useState(null);

    const widgetTargetRef = useRef(null);

    useEffect(() => {
        if(widgetImg){
            const widget = window.primerka(widgetTargetRef.current, widgetImg);
            setWidget(widget)
            // Удаляем из памяти при размонтировании, если не нужно сохранить кеш
            return () => {
                widget.destroy();
            }
        }

    }, [widgetTargetRef, widgetImg]);

    useEffect(() => {
        setDeviceUUID(
            document.cookie.replace(
                /(?:(?:^|.*;\s*)mindboxDeviceUUID\s*\=\s*([^;]*).*$)|^.*$/,
                "$1"
            )
        );
        setUserAgent(window.navigator.userAgent);
    }, []);

    const [sostavContent, setSostavContent] = useState([]);
    const [careSwitch, setCareSwitch] = useState("");
    const [activeCareIcons, setActiveCareIcons] = useState("");

    const stateCareSwitch = (item, index) => {
        setCareSwitch(item.text);
        setActiveCareIcons(index);
    };

    const [obmerContent, setObmerContent] = useState(null);
    const [allObmerContent, setAllObmerContent] = useState(null);
    const [activeObmerName, setActiveObmerName] = useState("");
    const [activeSertificateModal, setActiveSertificateModal] = useState(false);

    const wiewSertificateModal = () => {
        user.setShadowOverlay(true);
        setActiveSertificateModal(true);
    };

    const [userPreOrderFields, setUserPreOrderFields] = useState({
        name: "",
        telephone: "",
        email: "",
    });
    const [successState, setSuccessState] = useState(false);
    const [preOrderBtnClick, setPreOrderBtnClick] = useState(false);
    const [successStateModal, setSuccessStateModal] = useState(false);

    const userPreOrderChangeNameHandler = (value) => {
        setUserPreOrderFields({ ...userPreOrderFields, name: value });
    };
    const userPreOrderChangeTelephoneHandler = (value) => {
        if (!value) {
            setUserPreOrderFields({ ...userPreOrderFields, telephone: value }); //
        }
        setTelephoneCheckButton(value);
        setUserPreOrderFields({ ...userPreOrderFields, telephone: value });
    };
    const userPreOrderChangeEmailHandler = (value) => {
        setUserPreOrderFields({ ...userPreOrderFields, email: value });
    };

    const [errorPreOrderText, setErrorPreOrderText] = useState(null);

    const onClickPreOrderButtonHandler = () => {
        if (usesEnforcedCommerce(preOrderInfo?.item)) return;
        if (stateCheсkBoxPreorder === false) {
            setErrorPreOrderText("Примите соглашение");
            return false;
        }
        if (userPreOrderFields.name.length < 2) {
            setErrorPreOrderText("Укажите настоящее имя");
            return false;
        }
        if (userPreOrderFields.telephone.length < 2) {
            setErrorPreOrderText("Укажите настоящий телефон");
            return false;
        }
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (
            !emailPattern.test(userPreOrderFields.email) ||
            !userPreOrderFields.email
        ) {
            setErrorPreOrderText("Укажите настоящий Email");
            return false;
        }
        setErrorPreOrderText("");
        if (preOrderBtnClick) return;
        setPreOrderBtnClick(true);

        createPreOrder(
            preOrderInfo,
            userPreOrderFields,
            user.user,
            deviceUUID,
            userAgent
        ).then((response) => {
            if (response.error) {
                return false;
            }

            setSuccessState(true);
            setPreOrderInfo(null);
            setPreOrderBtnClick(false);

        });
    };

    const [nameProduct, setNameProduct] = useState([]);

    const [activeSliderComponents, setActiveSliderComponents] = useState(false);
    const [productComplects, setProductComplects] = useState("");
    const [productRecomendation, setProductRecomendation] = useState("");
    const [stateSwitchSlider, setStateSwitchSlider] = useState("image");

    const [scrollButtonBack, setScrollButtonBack] = useState(0);
    const [currentFilterCatalog, setCurrentFilterCatalog] = useState("");
    const [activeSizeId, setActiveSizeId] = useState("");
    const [deliveryContent, setDeliveryContent] = useState("");
    const [stocks, setStocks] = useState(false);

    const [galleryModal, setGalleryModal] = useState({
        isActive: false,
        index: 0,
    });

    const handleZoomClick = useCallback(() => {
        setGalleryModal({
            ...galleryModal,
            isActive: true,
        });
    }, [galleryModal, setGalleryModal]);

    const handleProductModalClose = useCallback(() => {
        setGalleryModal({
            ...galleryModal,
            isActive: false,
        });
    }, [galleryModal, setGalleryModal]);
    const productModalRef = useRef();
    const [productModalScrollWidth, setProductModalScrollWidth] = useState(0);
    useEffect(() => {
        if (galleryModal.isActive) {
            setProductModalScrollWidth(window.innerWidth - (productModalRef.current?.offsetWidth || 0));
        }
    }, [productModalRef, galleryModal.isActive]);

    useEffect(() => {
        let canceled = false;
        setGoRender(false);
        setNotFound(false);
        setLoadError(false);
        setOneProduct(null);
        setParent(null);
        setActiveChild(null);
        setActiveSizeChildProduct('');
        setActiveSizeId('');
        setStocks(false);
        setCurrentStock(false);
        setStockByCities({});
        setOpenModalStores(false);
        setOpenFastOrderModal(false);
        setOrderModalInfo(null);
        setOpenPreOrderModal(false);
        setPreOrderInfo(null);
        setActiveSertificateModal(false);
        setWidgetImg(null);
        setGalleryModal({isActive: false, index: 0});
        setSostavContent([]);
        setObmerContent(null);
        setAllObmerContent(null);
        setProductComplects('');
        setProductRecomendation('');
        setActiveSliderComponents(false);
        setLastViewed([]);
        getProduct(parrent, child, code).then((response) => {
            if (canceled) return;
            // получаем торговое предложение => продукт => остальные торг предложения
            if (response?.status === 404) {
                setNotFound(true);
                return;
            }
            const payload = response?.data;
            const envelope = payload?.publicSku;
            const publicSkuPresent = payload && Object.prototype.hasOwnProperty.call(payload, 'publicSku');
            const requested = payload?.data;
            const siblings = readDisplayRows(requested?.product?.childProducts, 200);
            const matches = siblings.filter(item => item.code === code);
            const enforce = envelope?.mode === 'enforced' || usesEnforcedCommerce(requested);
            const commerceAuthority = envelope?.mode === 'enforced' ? envelope : requested?.commerce;
            if (!response || !Number.isInteger(response.status) || response.status < 200 || response.status >= 300 ||
                !isRecord(requested) || !isRecord(requested.product) || requested.code !== code || matches.length !== 1 ||
                (publicSkuPresent && !validPublicSku(envelope)) ||
                (enforcedResponseSeen.current && !enforce) ||
                (enforce && siblings.some(item => !usesEnforcedCommerce(item) ||
                    item.commerce?.mode !== commerceAuthority?.mode ||
                    item.commerce?.schemaVersion !== commerceAuthority?.schemaVersion ||
                    item.commerce?.evaluatedAt !== commerceAuthority?.evaluatedAt))) {
                setLoadError(true);
                return;
            }
            if (enforce && (requested.is_active !== true || requested.product.active_product !== true)) {
                setNotFound(true);
                return;
            }
            if (enforce) enforcedResponseSeen.current = true;
            if (response && response.status !== 404) {
                response = response.data;
                if (window.turboTarget && window.turboTarget.sendRTGMessage) {
                    window.turboTargetPixelRTGViewProduct(response.data.product.id);
                } else {
                    document.addEventListener("generalPixelInited", () => {
                        window.turboTargetPixelRTGViewProduct(response.data.product.id)
                    })
                }

                //При переходе в торав обнуляем позицию скролла в каталоге и сохраняем значение в переменную
                setScrollButtonBack(settings.scrollStatusCatalog);
                settings.setScrollStatusCatalog(0);
                //При переходе в товар записывает значение фильтра и офнумяем
                setCurrentFilterCatalog(settings.stateFilerCatalog);
                settings.setStateFilerCatalog({
                    name: "по умолчанию",
                    code: "default",
                });
                setOneProduct(response.data.product);
                setParent(response.data);
                setStocks(response.stocks);
                const { active_sliders, active_complects, active_recomendation } =
                    response.data.product;
                if (active_sliders) {
                    getSliderData(response.data.product.id).then((response) => {
                        if (canceled) return;
                        const { complects, recomendation } = response.data;
                        setActiveSliderComponents(false);
                        if (active_complects && complects?.length > 0) {
                            setProductComplects(complects);
                            setActiveSliderComponents(true);
                            setStateSwitchSlider("image");
                        } else {
                            setStateSwitchSlider("like");
                        }
                        if (active_recomendation && recomendation?.length > 0) {
                            setProductRecomendation(recomendation);
                            setActiveSliderComponents(true);
                        }
                    });
                }

                if (lastViewedStore.lastViewed.length) {
                    getLastViewed(lastViewedStore.lastViewed).then(response => {
                        if (canceled) return;
                        if (response.data?.length) {
                            setLastViewed(response.data)
                        }
                    })
                }

                if (response.data.product.sostav) {
                    setSostavContent(readTextContentRows(response.data.product.sostav, 'sostav'));
                }
                // Если обмера нет или его нельзя сортировать - ничего не делаем. => не выводим
                // Заодно устанавливаем активным самый минимальный размер
                if (response.data.product.obmer) {
                    let parseObmer = readTextContentRows(response.data.product.obmer, 'obmer');

                    if (parseObmer[0]) {
                        let sortParseObmer = parseObmer.sort(
                            (a, b) => a.position - b.position
                        );

                        setActiveObmerName(sortParseObmer[0].size_name_obmer);
                        setObmerContent(sortParseObmer);
                        setAllObmerContent(parseObmer);
                    }
                }

                if (Array.isArray(response.data.product.landry_product_table) && response.data.product.landry_product_table.length) {
                    setActiveCareIcons(0);
                    setCareSwitch(response.data.product.landry_product_table[0].text);
                }

                let itemTosetActive = response.data.product.childProducts.filter(
                    (oneitem) => oneitem.code === code
                )[0];

                if (itemTosetActive) {
                    const title = itemTosetActive.title;
                    let description = "";
                    if (typeof itemTosetActive.product != "undefined") {
                        description =
                            itemTosetActive.product.description_product_content || "";
                    }

                    setProductProps({ title, description });
                    setActiveChild(itemTosetActive);

                    let str = typeof itemTosetActive.name === 'string' ? itemTosetActive.name.toLowerCase() : '';
                    let a = str.split("");
                    if (a.length) a[0] = a[0].toUpperCase();
                    let i = 0;
                    let s = "";
                    while (i < a.length) {
                        s = s + a[i];
                        i++;
                    }
                    setNameProduct(s);
                }
            } else {
                setNotFound(true);
                return;
            }
            getDataForBreadcrumbs(parrent, child, third, fourth).then((response) => {
                if (canceled) return;
                setBreadcrumbsparams(response);
                setGoRender(true);
            }).catch(() => {if (!canceled) setLoadError(true);});
        }).catch(() => {if (!canceled) setLoadError(true);});

        getCommonContent("delivery").then((response) => {
            if (!canceled && response?.success) {
                setDeliveryContent(response.content);
            }
        }).catch(() => {});
        return () => {canceled = true;};
    }, [parrent, child, third, fourth, code]);

    // A card can stay open longer than the five-minute public SKU grant. Fetch
    // a fresh server snapshot before it expires, preserving the chosen size.
    useEffect(() => {
        if (!activeChild || !usesEnforcedCommerce(activeChild)) return;
        const key = `${parrent}/${child}/${code}/${activeChild.id}`;
        if (commerceRefreshAttempt.current.key !== key) commerceRefreshAttempt.current = {key, at: 0};
        const evaluatedAt = Date.parse(activeChild.commerce?.evaluatedAt);
        const stockDeadline = Date.parse(getSizeCommerceView(activeChild, activeSizeChildProduct).descriptor?.stock?.validUntil);
        const refreshAt = Math.min(Number.isFinite(evaluatedAt) ? evaluatedAt + 4 * 60 * 1000 : Date.now(),
            Number.isFinite(stockDeadline) ? stockDeadline - 60 * 1000 : Infinity);
        let canceled = false;
        let inFlight = false;
        const refresh = async () => {
            if (canceled || inFlight || document.visibilityState === 'hidden' || Date.now() < refreshAt ||
                Date.now() - commerceRefreshAttempt.current.at < 60 * 1000) return;
            inFlight = true;
            commerceRefreshAttempt.current = {key, at: Date.now()};
            try {
                const result = await getProduct(parrent, child, code);
                if (canceled) return;
                const payload = result?.data;
                const requested = payload?.data;
                const siblings = readDisplayRows(requested?.product?.childProducts, 200);
                const routeMatches = siblings.filter(item => item.code === code);
                const selectedMatches = siblings.filter(item => item.id === activeChild.id);
                const envelope = payload?.publicSku;
                const authority = envelope?.mode === 'enforced' ? envelope : requested?.commerce;
                if (result?.status < 200 || result?.status >= 300 || !isRecord(requested) ||
                    !isRecord(requested.product) || requested.code !== code || routeMatches.length !== 1 ||
                    selectedMatches.length !== 1 || (Object.prototype.hasOwnProperty.call(payload, 'publicSku') && !validPublicSku(envelope)) ||
                    !siblings.every(item => usesEnforcedCommerce(item) && item.commerce?.mode === authority?.mode &&
                        item.commerce?.schemaVersion === authority?.schemaVersion && item.commerce?.evaluatedAt === authority?.evaluatedAt) ||
                    selectedMatches[0].is_active !== true || requested.product.active_product !== true ||
                    Date.parse(selectedMatches[0].commerce.evaluatedAt) < evaluatedAt) return;
                sizeBeforeCommerceRefresh.current = activeSizeChildProduct;
                setOneProduct(requested.product);
                setParent(requested);
                setStocks(payload.stocks);
                setActiveChild(selectedMatches[0]);
            } catch {} finally {
                if (!canceled) setCommerceRefreshRetry(value => value + 1);
            }
        };
        const timer = setTimeout(refresh, Math.max(1000, Math.min(2147483647,
            Math.max(refreshAt, commerceRefreshAttempt.current.at + 60 * 1000) - Date.now())));
        const onVisible = () => {if (document.visibilityState === 'visible') refresh();};
        document.addEventListener('visibilitychange', onVisible);
        window.addEventListener('focus', onVisible);
        return () => {
            canceled = true;
            clearTimeout(timer);
            document.removeEventListener('visibilitychange', onVisible);
            window.removeEventListener('focus', onVisible);
        };
    }, [parrent, child, code, activeChild, activeSizeChildProduct, commerceRefreshRetry]);

    useEffect(() => {
        if (activeChild && activeSizeChildProduct) {
            getCategories(activeChild.product.product_category).then(
                (categoriesResponse) => {
                    let category = "";
                    if (categoriesResponse.success) {
                        category = activeChild.product.product_category
                            .map((id) => categoriesResponse.data[id])
                            .join("/");
                        let productsArray = [];

                        let findSize = activeChild.child_product_size_field.find(
                            (item) => item.size_name === activeSizeChildProduct
                        );
                        if (findSize?.isActive) {
                            if (activeChild.child_product_size) {
                                let findSizeWithId = activeChild.child_product_size.find(
                                    (item) => item.size_name === findSize.size_name
                                );
                                if (findSizeWithId) {
                                    productsArray.push({
                                        id:
                                            String(activeChild.id) +
                                            String(activeChild.color.id) +
                                            findSizeWithId.id,
                                        name: activeChild.product.name,
                                        price: activeChild.sell_price
                                            ? activeChild.sell_price
                                            : activeChild.parrent_price,
                                        category: category,
                                        variant: activeChild.color.color_name,
                                    });
                                }
                            }
                        }
                        window.dataLayer.push({
                            event: "ym-ecom",
                            eCategory: "ecommerce",
                            eAction: "detail",
                            ecommerce: {
                                currencyCode: "RUB",
                                detail: {
                                    products: productsArray,
                                },
                            },
                        });
                    }
                }
            );
        }
    }, [activeChild, activeSizeChildProduct]);

    const [imgProduct, setImgProduct] = useState([]);
    const [activLinkPhoto, setActivLinkPhoto] = useState("");
    const [currentStock, setCurrentStock] = useState(false);
    const purchaseAvailable = isOrdinarySizeAvailable(activeChild, activeSizeChildProduct);
    const sizeCommerce = getSizeCommerceView(activeChild, activeSizeChildProduct);
    const isEnforced = usesEnforcedCommerce(activeChild);
    const preorderCartEnabled = process.env.REACT_APP_AUTOMATIC_PREORDER_SITE_CHECKOUT_ENABLED === 'true' ||
        process.env.REACT_APP_CONFIRMED_PREORDER_CART_ENABLED === 'true' &&
        process.env.REACT_APP_CONFIRMED_PREORDER_QUOTE_ENABLED === 'true';
    const draftCandidate = preorderCartEnabled && canDraftPreorder(activeChild, activeSizeChildProduct);
    const [draftError, setDraftError] = useState(null);
    useEffect(() => {setDraftError(null);}, [code, activeChild?.id, activeSizeChildProduct]);
    const addSelectedPreorder = () => {
        if (!preorderCartEnabled || !canDraftPreorder(activeChild, activeSizeChildProduct)) return;
        const result = basket.addPreorderProduct?.(activeChild, activeSizeChildProduct,
            {parentCategory: parrent, childCategory: child, code});
        setDraftError(result?.status === 'added' ? null : result?.error || 'Не удалось сохранить предзаказ в корзине. Попробуйте ещё раз.');
    };
    // Incoming stock can be confirmed independently of physical stock. This
    // exact public reason is only a calculator hint, never a checkout grant:
    // native options/quote/accept validate the incoming batch, quota and ETA.
    const quoteCandidate = !preorderCartEnabled && process.env.REACT_APP_CONFIRMED_PREORDER_QUOTE_ENABLED === 'true' &&
        isEnforced && activeChild?.is_active === true && activeChild?.product?.active_product === true &&
        activeChild?.product?.electron_sertificate !== true && sizeCommerce.descriptor?.kind === 'ordinary' &&
        Date.parse(activeChild?.commerce?.evaluatedAt) <= Date.now() && !sizeCommerce.available &&
        ['preorders_disabled', 'preorder_ready', 'preorder_quota_freshness_invalid'].includes(sizeCommerce.descriptor?.reasonCode);
    const quoteKey = `${code}:${activeChild?.id}:${sizeCommerce.descriptor?.sizeId}:${user.user?.id}`;
    const pendingQuoteKey = !preorderCartEnabled && user.isAuth && process.env.REACT_APP_CONFIRMED_PREORDER_ACCEPTANCE_ENABLED === 'true'
        ? pendingConfirmedPreorderKey(user.user?.id, {childProductId: activeChild?.id, colorId: activeChild?.colorId,
            sizeId: sizeCommerce.descriptor?.sizeId}) : null;
    const [openQuoteKey, setOpenQuoteKey] = useState(null);
    useEffect(() => {setOpenQuoteKey(pendingQuoteKey ? quoteKey : null);}, [quoteKey, user.isAuth]);
    const requestedBasketQuantity = (item, sizeName) => {
        let quantity = 1;
        for (const line of basket.basketItems || []) {
            if (line.item?.id !== item?.id || line.currentSize !== sizeName) continue;
            if (!Number.isSafeInteger(line.count) || line.count <= 0) return NaN;
            quantity += line.count;
            if (!Number.isSafeInteger(quantity)) return NaN;
        }
        return quantity;
    };
    const canAddSelected = !isEnforced || isOrdinarySizeAvailable(activeChild, activeSizeChildProduct,
        requestedBasketQuantity(activeChild, activeSizeChildProduct));
    useEffect(() => {
        if (sizeCommerce.expiresAt === null || sizeCommerce.expiresAt < Date.now()) return;
        const timer = setTimeout(() => setCommerceClock(value => value + 1),
            Math.min(2147483647, Math.max(1, sizeCommerce.expiresAt - Date.now() + 1)));
        return () => clearTimeout(timer);
    }, [activeChild, activeSizeChildProduct, sizeCommerce.expiresAt, commerceClock]);
    const [stockByCity, setStockByCities] = useState({});
    const [openModalStores, setOpenModalStores] = useState(false);

    useEffect(() => {
        if(openModalStores){
            user.setShadowOverlay(true)
        } else {
            user.setShadowOverlay(false)
        }
    }, [openModalStores]);

    useEffect(() => {
        // Размер не заказуем онлайн -> собираем города, где он есть в магазинах (для модалки).
        if(!purchaseAvailable && Array.isArray(currentStock) && currentStock.length){
            const index = currentStock[0].indexOf(activeSizeChildProduct);
            if (index < 1) {
                setStockByCities({});
                return;
            }
            let stocksByCities = {}
            currentStock.forEach(item => {
                if(item[0].stock?.market && item[index]){
                    if(stocksByCities[item[0].stock?.market.city_name] == undefined)
                        stocksByCities[item[0].stock?.market.city_name] = []
                    stocksByCities[item[0].stock?.market.city_name].push(item[0].stock)
                }
            })
            setStockByCities(stocksByCities)
        } else {
            setStockByCities({})
        }
    }, [activeSizeChildProduct, currentStock, purchaseAvailable]);

    useEffect(() => {
        if (!activeChild) {
            return false;
        }

        let parseImg = readDisplayRows(activeChild.other_images);

        let object = { imageProd: [] };

        if (activeChild.img_first) {
            let previewsPhoto = object.imageProd;
            previewsPhoto.push({ linkImg: activeChild.img_first });
            object = { ...object, imageProd: previewsPhoto };
        }

        for (const oneImage of parseImg) {
            let arrayOnePhoto = object.imageProd;
            if (oneImage.one_image != null && oneImage.one_image != "") {
                arrayOnePhoto.push({ linkImg: oneImage.one_image });
                object = { ...object, imageProd: arrayOnePhoto };
            }
        }

        for (const twoImage of parseImg) {
            let arrayTwoPhoto = object.imageProd;
            if (twoImage.two_image != null && twoImage.two_image != "") {
                arrayTwoPhoto.push({ linkImg: twoImage.two_image });
                object = { ...object, imageProd: arrayTwoPhoto };
            }
        }

        for (const threeImage of parseImg) {
            let arrayThreePhoto = object.imageProd;
            if (threeImage.three_image != null && threeImage.three_image != "") {
                arrayThreePhoto.push({ linkImg: threeImage.three_image });
                object = { ...object, imageProd: arrayThreePhoto };
            }
        }

        for (const fourImage of parseImg) {
            let arrayFourPhoto = object.imageProd;
            if (fourImage.four_image != null && fourImage.four_image != "") {
                arrayFourPhoto.push({ linkImg: fourImage.four_image });
                object = { ...object, imageProd: arrayFourPhoto };
            }
        }

        setImgProduct([object][0].imageProd);

        let builtCurrentStock = false;
        const enabledSizeNames = new Set(
            readDisplayRows(activeChild.child_product_size_field, 256)
                .filter(item => item.isActive === true)
                .map(item => item.size_name)
        );
        let sizes = [...readDisplayRows(activeChild.child_product_size, 500)]
            .filter(item => item.isActive && enabledSizeNames.has(item.size_name))
            .sort((a, b) => a.position - b.position);

        if (usesEnforcedCommerce(activeChild)) {
            builtCurrentStock = buildInformationalRetailTable(activeChild);
        } else if (sizes.some(item => parseWarehouseStocks(item.childProduct_Size?.stocks))) {
            let st = [];
            let header = ['Магазины'];
            sizes.forEach((item) => {
                header.push(item.size_name);
            });
            st.push(header);

            (Array.isArray(stocks) ? stocks : []).forEach((stock) => {
                let row = [];
                if (stock.warehouse.market) {
                    row.push({ stock: stock.warehouse });
                    sizes.forEach((item) => {
                        let itemStocks = parseWarehouseStocks(item.childProduct_Size?.stocks);
                        if (itemStocks && itemStocks[stock.warehouse.code]) {
                            row.push(checkStock(stock.warehouse.code, itemStocks[stock.warehouse.code]));
                        } else {
                            row.push(false);
                        }
                    });
                    st.push(row);
                }
            });

            builtCurrentStock = st.length > 1 ? st : false;
        }

        setCurrentStock(builtCurrentStock);

        let sortPositionSize = [...readDisplayRows(activeChild.child_product_size_field, 256)].sort(
            (a, b) => a.position - b.position
        );

        let filterNotAvailable = sortPositionSize.filter(
            (item) => item.size_name !== ""
        );

        if (filterNotAvailable[0]) {
            let activeSizes = filterNotAvailable.filter(
                (item) => item.isActive === true
            );

            // Предвыбираем первый размер, для которого показывается кнопка "Добавить в корзину":
            let findSizeActive =
                activeSizes.find(item => item.size_name === sizeBeforeCommerceRefresh.current) ||
                activeSizes.find(
                    (item) => isOrdinarySizeAvailable(activeChild, item.size_name)
                ) ||
                activeSizes[0];
            sizeBeforeCommerceRefresh.current = null;

            if (findSizeActive) {
                setActiveSizeChildProduct(findSizeActive.size_name);
                setActiveSizeId(findSizeActive.sizeId);
                setActiveButtonNotification(!isOrdinarySizeAvailable(activeChild, findSizeActive.size_name));
            }
        } else {
            setActiveSizeChildProduct('');
            setActiveSizeId('');
            setActiveButtonNotification(true);
        }
    }, [activeChild, stocks]);

    useEffect(() => {
        if (activeChild) {
            if(activeChild.widget_file){
                setWidgetImg(process.env.REACT_APP_API_URL +
                    "uploads/images/" +
                    activeChild.productId +
                    "/" +
                    activeChild.id +
                    "/" +
                    "950_" +
                    activeChild.widget_file)
            }

            lastViewedStore.addViewed(activeChild.id);
        }
    }, [activeChild])

    useEffect(() => {
        if (user.isAuth) {
            setUserPreOrderFields({
                name: user.user.name ? user.user.name : "",
                telephone: user.user.telephone ? user.user.telephone : "",
                email: user.user.email ? user.user.email : "",
            });
        }
    }, [user.isAuth]);
    // Стейты открытых вкладышей, НЕ СВЯЗАНЫ С КОНТЕНТОМ, это тригеры открытий

    const [descriptionState, setDescriptionState] = useState(false);
    const [deliveryState, setDeliveryState] = useState(false);
    const [sostavState, setSostavState] = useState(false);
    const [obmerState, setObmerState] = useState(false);
    const [callbackState, setCallbackState] = useState(false);
    const [stockState, setStockState] = useState(false);

    function getCurrentObmerToSizeName() {
        if (!obmerContent) {
            return false;
        }
        let filterObmer = obmerContent.filter(
            (item) => item.size_name_obmer === activeObmerName
        )[0];
        return filterObmer;
    }

    function checkStock(code, stock){
        return stock > 0
    }

    function checkAvailItem(item){
        if(item.available){
            for(let i in item.stocks){
                if(checkStock(i, item.stocks[i])){
                    return true;
                }
            }
            if(typeof item.stocks === 'undefined' || item.stocks.length <= 0){
                return true;
            }
        }
        return false;
    }

    const changeActiveProductToColor = (item) => {
        let isActiveOldColor = readDisplayRows(item.child_product_size_field, 256).filter(
            (item) => item.size_name === activeSizeChildProduct
        );

        setActivLinkPhoto("");
        setActiveSizeChildProduct('');
        setActiveSizeId('');
        setOpenFastOrderModal(false);
        setOrderModalInfo(null);
        setOpenPreOrderModal(false);
        setPreOrderInfo(null);
        setActiveSertificateModal(false);
        setActiveChild(item);
    };

    function getClassForSize(item) {
        const available = usesEnforcedCommerce(activeChild)
            ? getSizeCommerceView(activeChild, item.size_name).available
            : activeChild.coming_soon
            ? item.available !== false
            : isOrdinarySizeAvailable(activeChild, item.size_name);
        if (!available) {
            if (item.size_name === activeSizeChildProduct) {
                return "page_product_size_one_item not_available active";
            }
            return "page_product_size_one_item not_available";
        }
        if (item.size_name === activeSizeChildProduct) {
            return "page_product_size_one_item active";
        }
        return "page_product_size_one_item";
    }

    const [activeButtonNotification, setActiveButtonNotification] =
        useState(true);

    const changeSizeChildProduct = (item) => {
        if (!isOrdinarySizeAvailable(activeChild, item.size_name)) {
            setActiveSizeChildProduct(item.size_name);
            setActiveSizeId(item.sizeId);
            setActiveButtonNotification(true);
            return false;
        }
        setActiveSizeChildProduct(item.size_name);
        setActiveSizeId(item.sizeId);
        setActiveButtonNotification(false);
    };

    const addToBasketHandlerProductPage = (item, currentSize) => {
        if (usesEnforcedCommerce(item) && !isOrdinarySizeAvailable(item, currentSize,
            requestedBasketQuantity(item, currentSize))) {
            setCommerceClock(value => value + 1);
            return false;
        }
        basket.addProduct(item, currentSize);
        setCommerceClock(value => value + 1);
        return true;
    };

    const [openFastOrderModal, setOpenFastOrderModal] = useState(false);
    const [orderModalInfo, setOrderModalInfo] = useState(null);
    const modalCommerce = getSizeCommerceView(orderModalInfo?.item, orderModalInfo?.currentSize, orderModalInfo?.count);

    const addToFieldsProductModal = (
        activeChild,
        activeSizeChildProduct,
        isFastOrder = false
    ) => {
        if (!isFastOrder) return;
        if (usesEnforcedCommerce(activeChild)) {
            const view = getSizeCommerceView(activeChild, activeSizeChildProduct,
                isFastOrder ? requestedBasketQuantity(activeChild, activeSizeChildProduct) : 1);
            if (view.action !== 'buy_now') return;
        }
        setOrderModalInfo({
            child_product_id: activeChild.id,
            colorId: activeChild.colorId,
            count: 1,
            currentSize: activeSizeChildProduct,
            item: activeChild,
            productId: activeChild.product.id,
        });
        setOpenFastOrderModal(true);
        setSuccessStateModal(false);
        user.setShadowOverlay(true);
    };

    const [preOrderInfo, setPreOrderInfo] = useState(null);
    const [openPreOrderModal, setOpenPreOrderModal] = useState(false);

    const preOrderModalGo = (
        activeChild,
        userId,
        activeSizeChildProduct,
        count
    ) => {
        if (usesEnforcedCommerce(activeChild)) return;
        setPreOrderInfo({
            child_product_id: activeChild.id,
            colorId: activeChild.colorId,
            count: 1,
            currentSize: activeSizeChildProduct,
            item: activeChild,
            productId: activeChild.product.id,
        });
        setSuccessState(false);

        setOpenPreOrderModal(true);
        user.setShadowOverlay(true);
    };

    const closeModalPreOrder = () => {
        setPreOrderInfo(null);
        user.setShadowOverlay(false);
        setOpenPreOrderModal(false);
        setActiveSertificateModal(false);
    };

    useEffect(() => {
        if (user.shadowOverlay !== true) {
            setPreOrderInfo(null);
            setOpenPreOrderModal(false);
            setActiveSertificateModal(false);
        }
    }, [user.shadowOverlay]);

    const countChangeHandler = (param) => {
        if (param === "min") {
            if (preOrderInfo.count === 1) {
                return false;
            }
            setPreOrderInfo({ ...preOrderInfo, count: preOrderInfo.count - 1 });
        }
        if (param === "max") {
            setPreOrderInfo({ ...preOrderInfo, count: preOrderInfo.count + 1 });
        }
        return false;
    };

    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [stateCheсkBoxPreorder, setStateCheсkBoxPreorder] = useState(false);

    // требуемое расстояние между touchStart и touchEnd для определения в виде свайпа
    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
        setTouchEnd(null); // в противном случае свайп срабатывает даже при обычных событиях касания
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        // добавьте сюда свою условную логику
        if (imgProduct !== "") {
            let lastElementArray = imgProduct.length;
            if (!activLinkPhoto) {
                setActivLinkPhoto(imgProduct[0].linkImg);
            } else {
                let indexLink = 0;
                let isFindСoincidenceLink = false;
                let customIndex = 0;
                for (const oneLinkSwipeImg of imgProduct) {
                    if (activLinkPhoto === oneLinkSwipeImg.linkImg) {
                        customIndex = indexLink;
                        isFindСoincidenceLink = true;
                    }
                    indexLink++;
                }

                if (isFindСoincidenceLink) {
                    if (isLeftSwipe) {
                        if (customIndex === lastElementArray - 1) {
                            setActivLinkPhoto(imgProduct[0].linkImg);
                            return false;
                        }
                        setActivLinkPhoto(imgProduct[customIndex + 1].linkImg);
                    }
                    if (isRightSwipe) {
                        if (customIndex === 0) {
                            setActivLinkPhoto(imgProduct[lastElementArray - 1].linkImg);
                            return false;
                        }
                        setActivLinkPhoto(imgProduct[customIndex - 1].linkImg);
                    }
                }
            }
        }
        return false;
    };

    // Кнопка назад, проверяет есть ли ссылка назад, если нет то в каталог
    const location = useLocation();
    const navigate = useNavigate();
    const hasPreviousState = location.key !== "default";

    //Отслеживаем клик назад и устанавливаем значение скролла страницы
    window.onpopstate = () => {
        settings.setScrollStatusCatalog(scrollButtonBack);
        settings.setStateFilerCatalog(currentFilterCatalog);
        settings.setProductFilterFromState(true);
    };


    const showWidget = () => {
        if(widget){
            widget.open()
        }
    }


    const handleClick = () => {
        if (hasPreviousState) {
            navigate(-1);
            settings.setScrollStatusCatalog(scrollButtonBack);
            settings.setStateFilerCatalog(currentFilterCatalog);
        } else if (child && parrent) {
            navigate("/catalog/" + parrent + "/" + child + "/");
        } else if (parrent) {
            navigate("/catalog/" + parrent + "/");
        } else {
            navigate("/catalog/");
        }
    };

    const nameProductLowerCase = () => {
        if (nameProduct) {
            var lower = nameProduct.toLowerCase();
            return lower;
        }
        return "";
    };

    let countryArray = phoneCountryArr;
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [telephone, setTelephone] = useState("");
    const [email, setEmail] = useState("");
    const [fio, setFio] = useState("");
    const [openSelectorCountry, setOpenSelectorCountry] = useState(false);

    const [validSertText, setValidSertText] = useState("");

    useEffect(() => {
        setSelectedCountry(countryArray[0]);
    }, []);

    const validBuySertificate = () => {
        if (usesEnforcedCommerce(activeChild) &&
            getSizeCommerceView(activeChild, activeSizeChildProduct).action !== 'certificate') return;
        setValidSertText("");
        if (fio.length < 8) {
            setValidSertText("Пожалуйста, укажите свое ФИО.");
            return false;
        }
        let replacenumber = telephone.replace(/[^\d]/g, "");
        if (Number(replacenumber.length) !== Number(maskState.number)) {
            setValidSertText("Пожалуйста, укажите номер.");
            return false;
        }
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email) || !email) {
            setValidSertText("Укажите настоящий Email");
            return false;
        }
        let preOrderInfo = {
            child_product_id: activeChild.id,
            colorId: activeChild.colorId,
            count: 1,
            currentSize: activeSizeChildProduct,
            item: activeChild,
            productId: activeChild.product.id,
        };
        сreateSertificateOrder(
            preOrderInfo,
            { fio, telephone, email },
            user.user
        ).then((response) => {
            Navigate("/order/id/" + response.order.custom_order_id + "/");
        }).catch((error) => {
            setValidSertText(error?.response?.status === 409
                ? "Сертификат недоступен или его данные изменились. Обновите страницу товара."
                : "Не удалось оформить сертификат. Попробуйте позже.");
        });
    };

    useEffect(() => {
        if (activeChild && activeSizeId) {
            const currentSize = activeChild.child_product_size?.find(
                (item) => item.id === activeSizeId
            );
            const guid = usesEnforcedCommerce(activeChild)
                ? getSizeCommerceView(activeChild, activeSizeChildProduct).descriptor?.offerId
                : currentSize?.childProduct_Size?.guid ?? activeChild.id;
            if (!guid) return;
            mindBox.personalization.viewProduct({ id: guid });
            mindboxViewProduct(deviceUUID, userAgent, guid);
            mindboxAddProductToProsmotrennyeItemList(
                deviceUUID,
                userAgent,
                guid,
                activeChild.product.price
            );
        }
    }, [activeChild, activeSizeId]);

    if (notFound) {
        return <NotFound />;
    }
    if (loadError) return <div role="alert">Не удалось загрузить товар</div>;

    const getOfferId = () => {
        if (usesEnforcedCommerce(activeChild)) {
            return getSizeCommerceView(activeChild, activeSizeChildProduct).descriptor?.offerId || '';
        }
        let id =
            activeChild.id.toString() +
            activeChild.color.id.toString() +
            activeSizeId.toString();
        return id;
    };

    const ToggleShowContry = () => {
        if (searchStateShow === "unactive") {
            setSearchStateShow("active");
        } else {
            setSearchStateShow("unactive");
        }
    };

    const getSortedCountry = () => {
        if (searchQuery) {
            return [...phoneCountryArr].filter((country) =>
                country.name
                    .toLocaleLowerCase()
                    .includes(searchQuery.toLocaleLowerCase())
            );
        }
        return phoneCountryArr;
    };

    const sortedArr = getSortedCountry();

    const changeModelInput = (object) => {
        setMaskState(object);
        setTelephoneCheckButton("");
        ToggleShowContry();
        user.setCountry(object.name);
    };

    const setTelephoneCheckButton = (number) => {
        user.setPhoneNumber(number);
        let replacenumber = number.replace(/[^\d]/g, "");
        //устанавливаем кликабельность кнопки "получить код"
        if (Number(replacenumber.length) === Number(maskState.number)) {
            user.setGetMeCodeButton("active");
        } else {
            user.setGetMeCodeButton("unactive");
        }
    };

    const toogleStockDetail = (e) => {
        e.target.closest('.stockDetail').classList.toggle("hidden")
    }

    return (
        <div
            id={"one_product_page_wrapper"}
            style={{ marginTop: settings.headerHeight }}
            className={"one_product_page_wrapper"}
        >
            {
                activeChild?.widget_file ? (<div className="widgetButton" onClick={(e) => showWidget()}>Примерить на себе</div>) : ''
            }

            <div ref={widgetTargetRef} className="widgetTarget"></div>
            <div className={
                openModalStores
                    ? "modal_stores active"
                    : "modal_stores"
            }>
                <div className="modal_stores_wrapper_for_content">
                    <div className="notification_modal_heading_line_and_exit"><span
                        className="notification_modal_heading_text"> Размер {activeSizeChildProduct} в магазинах</span>
                        <div className="notification_modal_exit_div" onClick={() => setOpenModalStores(false)}></div>
                    </div>
                    <div className="relative_container_for_notification">
                        <div className="modal_content_notification">
                            {
                                Object.keys(stockByCity).length > 0 ? Object.keys(stockByCity).map((item, index) => {
                                    return (
                                        <div key={index} className="stockDetail">
                                            <div className="stockDetail_city" onClick={(e) => toogleStockDetail(e)}>
                                                Город: <span>{item}</span>
                                                <span className={"stockDetail_arrow"}>
                                                    <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0.862549 0.862869L5.38527 4.86287L9.86255 0.86287" stroke="#1A1A1A" stroke-width="1.22222" stroke-linecap="square" stroke-linejoin="round"/>
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="stockDetail_wrapper_for_stocks">
                                                {
                                                    stockByCity[item].map((oneStock, index) => {
                                                        return (
                                                            <div key={index} className="stockDetail_one_stock">
                                                                <div className="stockDetail_one_stock_name">{oneStock.market.name_market}</div>
                                                                <div className="stockDetail_one_stock_prop_value">{oneStock.market.address}</div>
                                                                <div className="stockDetail_one_stock_prop_wrapper">
                                                                    <div className="stockDetail_one_stock_prop_item">
                                                                        <div className="stockDetail_one_stock_prop_name">Режим работы </div>
                                                                        <div className="stockDetail_one_stock_prop_value">{oneStock.market.work_schedule}</div>
                                                                    </div>
                                                                    <div className="stockDetail_one_stock_prop_item">
                                                                        <div className="stockDetail_one_stock_prop_name">Номер телефона </div>
                                                                        <div className="stockDetail_one_stock_prop_value">{oneStock.market.front_number}</div>
                                                                    </div>
                                                                </div>
                                                                {oneStock.market.map_url && <a href={oneStock.market.map_url} target={"_blank"} rel="noopener noreferrer" className="stockDetail_one_stock_link">подробнее</a>}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                }) : ''
                            }
                        </div>
                    </div>
                </div>
            </div>
            {!preorderCartEnabled && user.isAuth && activeChild && sizeCommerce.descriptor && openQuoteKey === quoteKey && <ConfirmedPreorderQuoteForm
                key={quoteKey}
                principalId={user.user?.id}
                target={{childProductId: activeChild.id, colorId: activeChild.colorId,
                    sizeId: sizeCommerce.descriptor.sizeId, categoryPath: null}}
                offerId={sizeCommerce.descriptor.offerId} sizeName={activeSizeChildProduct}
                onClose={() => setOpenQuoteKey(null)} />}
            <FastOrderPopup
                stockPending={modalCommerce.stockPending}
                setOpenFastOrderModal={(e) => setOpenFastOrderModal(e)}
                openFastOrderModal={openFastOrderModal}
                orderModalInfo={orderModalInfo}
                setOrderModalInfo={(e) => setOrderModalInfo(e)}
                oneProduct={oneProduct}
                setSuccessStateModal={(e) => setSuccessStateModal(e)}
                successStateModal={successStateModal}
            />
            {activeChild &&
            activeChild.product.electron_sertificate &&
            activeSertificateModal ? (
                <div className={"modal_sertificate"}>
                    <div
                        onClick={(e) => closeModalPreOrder()}
                        className={"sertificate_close"}
                    >
                        <div className={"sertificate_close_child"}></div>
                    </div>
                    <div className={"modal_sertificate_no_pos"}>
                        <div className={"heading_sertificate_modal"}>
                            Купить электронный сертификат
                        </div>
                        <div className={"cute_form_wrapper"}>
                            <span className={"cute_notificator"}>
                                Просим заполнить корректно свои данные. Код сертификата будет
                                отправлен по смс, а также на указанный e-mail{" "}
                            </span>
                            <div className={"cute_field_wrapper"}>
                                <span className={"cute_field_notif"}>
                                    Ф.И.О<span className={"red_cute"}>*</span>
                                </span>
                                <input
                                    value={fio ? fio : ""}
                                    onChange={(e) => setFio(e.target.value)}
                                    className={"cute_input"}
                                    type="text"
                                />
                            </div>
                            <div className={"cute_field_wrapper"}>
                                <span className={"cute_field_notif"}>
                                    Номер телефона<span className={"red_cute"}>*</span>
                                </span>
                                <div className={"wrapper_for_cute_input"}>
                                    <div className={"box_for_select_country"}>
                                        <div
                                            onClick={(e) =>
                                                setOpenSelectorCountry(!openSelectorCountry)
                                            }
                                            className={"current_cut_country"}
                                        >
                                            <img src={selectedCountry.imgPath} alt="" />
                                        </div>
                                        {openSelectorCountry ? (
                                            <div className={"wrapper_for_w_selected"}>
                                                {countryArray.map((item, index) => {
                                                    return (
                                                        <div
                                                            onClick={(e) => (
                                                                setSelectedCountry(item),
                                                                    setOpenSelectorCountry(false)
                                                            )}
                                                            className={"cute_one_selector"}
                                                            key={index}
                                                        >
                                                            <img src={item.imgPath} alt="" />
                                                            <span>{item.name}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <InputMask
                                        className={"cute_input anlg"}
                                        placeholder={selectedCountry.placeholder}
                                        mask={selectedCountry.mask}
                                        value={telephone ? telephone : ""}
                                        onChange={(e) => setTelephone(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={"cute_field_wrapper"}>
                                <span className={"cute_field_notif"}>
                                    E-mail<span className={"red_cute"}>*</span>
                                </span>
                                <input
                                    value={email ? email : ""}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={"cute_input"}
                                    type="text"
                                />
                            </div>
                            <div className={"validator_cute_line"}>{validSertText}</div>
                            <div
                                onClick={(e) => validBuySertificate()}
                                className={"buy_sertificate_btn"}
                            >
                                Купить
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}

            {goRender && breadcrumbsParams && oneProduct && activeChild ? (
                <div
                    className={"page_one_product_wrapper_for_components"}
                    itemScope
                    itemType="http://schema.org/Product"
                >
                    {oneProduct && (
                        <>
                            <Helmet>
                                <title>
                                    {productProps.title
                                        ? productProps.title
                                        : "Купить " +
                                        nameProductLowerCase() +
                                        " - " +
                                        oneProduct.articul +
                                        " в интернет-магазине YOU WANNA"}
                                </title>
                                <meta
                                    name="description"
                                    content={
                                        productProps.description
                                            ? productProps.description
                                            : nameProduct +
                                            " - " +
                                            oneProduct.articul +
                                            " в YOU WANNA! По имеющимся вопросам звоните: ☎ +7 (926) 887-70-07."
                                    }
                                />
                                <link
                                    rel="canonical"
                                    href={
                                        apiUrlWithoutSlash +
                                        (activeChild.product && activeChild.code
                                            ? (activeChild.product.canonical_prefix ||
                                                  activeChild.product.product_url) + activeChild.code
                                            : "") +
                                        "/"
                                    }
                                />
                            </Helmet>
                            <div
                                itemProp="aggregateRating"
                                itemScope=" "
                                itemType="http://schema.org/AggregateRating"
                            >
                                <meta itemProp="ratingValue" content={5} />
                                <meta itemProp="reviewCount" content={17} />
                            </div>
                            <meta itemProp="brand" content="YOU-WANNA" />
                            <meta itemProp="name" content={oneProduct.name || "YOU WANNA"} />
                            <meta
                                itemProp="description"
                                content={productProps.description || ""}
                            />

                            <div
                                itemScope=" "
                                itemProp="offers"
                                itemType="http://schema.org/Offer"
                            >
                                <meta itemProp="price" content={oneProduct.price} />
                                <meta itemProp="priceCurrency" content="RUB" />
                                <link
                                    itemProp="availability"
                                    href={isEnforced && !sizeCommerce.available
                                        ? "https://schema.org/OutOfStock" : "https://schema.org/InStock"}
                                />
                            </div>
                        </>
                    )}
                    <div
                        className={
                            openPreOrderModal
                                ? "pre_order_modal_for_new_order active"
                                : "pre_order_modal_for_new_order"
                        }
                    >
                        <div
                            className={
                                successState
                                    ? "pre_order_modal_wrapper_for_content non_border"
                                    : "pre_order_modal_wrapper_for_content"
                            }
                        >
                            <div className={"pre_order_modal_heading_line_and_exit"}>
                                {preOrderInfo && !successState ? (
                                    <span className={"order_modal_heading_text"}>
                                        {" "}
                                        Оформить предзаказ{" "}
                                    </span>
                                ) : (
                                    ""
                                )}
                                <div
                                    onClick={(e) => closeModalPreOrder()}
                                    className={"order_modal_exit_div"}
                                ></div>
                            </div>
                            <div
                                className={
                                    successState
                                        ? "relative_container_for_pre_order non_border"
                                        : "relative_container_for_pre_order"
                                }
                            >
                                {preOrderInfo && !successState ? (
                                    <div className={"modal_content_pre_order"}>
                                        <div className="modal_content_pre_order_heading_line">
                                            Данный товар доступен только по предзаказу. Менеджер
                                            свяжется с Вами после оформления.{" "}
                                        </div>
                                        <div className={"modal_content_pre_order_wrapper_for_row"}>
                                            <div className={"modal_content_pre_order_img_container"}>
                                                <img
                                                    src={
                                                        process.env.REACT_APP_API_URL +
                                                        "uploads/images/" +
                                                        preOrderInfo.item.productId +
                                                        "/" +
                                                        preOrderInfo.item.id +
                                                        "/" +
                                                        "214_" +
                                                        preOrderInfo.item.img_preview
                                                    }
                                                    alt={
                                                        (nameProduct ? nameProduct : "") +
                                                        "; цвет: " +
                                                        (preOrderInfo.item.color.color_name
                                                            ? preOrderInfo.item.color.color_name
                                                            : "")
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={
                                                    "modal_content_pre_order_wrapper_for_column_content"
                                                }
                                            >
                                                <div className="modal_content_pre_order_name_line">
                                                    {preOrderInfo.item.name}
                                                </div>
                                                <div className={"modal_content_pre_order_color_name"}>
                                                    <span
                                                        className={"modal_content_pre_order_black_span"}
                                                    >
                                                        Цвет:{" "}
                                                    </span>{" "}
                                                    <span>{preOrderInfo.item.color.color_name}</span>
                                                </div>
                                                <div className={"modal_content_pre_order_color_name"}>
                                                    <span
                                                        className={"modal_content_pre_order_black_span"}
                                                    >
                                                        Размер:{" "}
                                                    </span>{" "}
                                                    <span>{preOrderInfo.currentSize}</span>
                                                </div>
                                                <div className={"modal_content_pre_order_color_name"}>
                                                    <span
                                                        className={"modal_content_pre_order_black_span"}
                                                    >
                                                        Количество:{" "}
                                                    </span>

                                                    <div
                                                        className={"wrapper_for_mini_count_controller_wp"}
                                                    >
                                                        <div
                                                            className={
                                                                "wrapper_for_mini_count_controller min"
                                                            }
                                                            onClick={(e) => countChangeHandler("min")}
                                                        ></div>
                                                        <div
                                                            className={
                                                                "wrapper_for_mini_count_controller center"
                                                            }
                                                        >
                                                            {preOrderInfo.count}
                                                        </div>
                                                        <div
                                                            className={
                                                                "wrapper_for_mini_count_controller max"
                                                            }
                                                            onClick={(e) => countChangeHandler("max")}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {!preOrderInfo.item.price_hidden ? (
                                                    <div className={"modal_content_pre_order_color_name"}>
                                                        <span
                                                            className={"modal_content_pre_order_black_span"}
                                                        >
                                                            Цена:{" "}
                                                        </span>{" "}
                                                        <span className={"one_product_page_price"}>
                                                            {preOrderInfo.item.sell_price
                                                                ? priceToUserString(
                                                                preOrderInfo.item.sell_price *
                                                                preOrderInfo.count
                                                            ) + " ₽"
                                                                : ""}
                                                        </span>{" "}
                                                        <span
                                                            className={
                                                                preOrderInfo.item.sell_price
                                                                    ? "standard_price old_price"
                                                                    : "standard_price"
                                                            }
                                                        >
                                                            {priceToUserString(
                                                                oneProduct.price * preOrderInfo.count
                                                            ) + " ₽"}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>
                                        <div className={"pre_order_fields_modal"}>
                                            <div className={"pre_order_fields_wrapper"}>
                                                <span>Имя *</span>
                                                <input
                                                    value={
                                                        userPreOrderFields.name
                                                            ? userPreOrderFields.name
                                                            : ""
                                                    }
                                                    onChange={(e) =>
                                                        userPreOrderChangeNameHandler(e.target.value)
                                                    }
                                                    type="text"
                                                />
                                            </div>
                                            <div className={"pre_order_fields_wrapper"}>
                                                <span>Телефон *</span>
                                                <div className={"registration_select_class"}>
                                                    <div className={"phone_and_city_wrap"}>
                                                        <div
                                                            onClick={(e) => ToggleShowContry()}
                                                            className={"selected_input_wrapper"}
                                                        >
                                                            <img src={maskState.imgPath} alt="" />
                                                        </div>
                                                        <div className={"searchResults " + searchStateShow}>
                                                            <div className={"wrapSearchInput"}>
                                                                <input
                                                                    type="text"
                                                                    className={"searchInput"}
                                                                    placeholder={"Введите название страны"}
                                                                    value={searchQuery}
                                                                    onChange={(e) =>
                                                                        setSearchQuery(e.target.value)
                                                                    }
                                                                />
                                                            </div>

                                                            {sortedArr.length ? (
                                                                sortedArr.map((country, name) => (
                                                                    <OptionCountry
                                                                        onClick={(e) => changeModelInput(country)}
                                                                        key={name}
                                                                        country={country}
                                                                    />
                                                                ))
                                                            ) : (
                                                                <p>
                                                                    К сожалению, такой страны нет. Свяжитесь с
                                                                    менеджером.{" "}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <InputMask
                                                        placeholder={maskState.placeholder}
                                                        mask={maskState.mask}
                                                        value={
                                                            userPreOrderFields.telephone
                                                                ? userPreOrderFields.telephone
                                                                : ""
                                                        }
                                                        onChange={(e) =>
                                                            userPreOrderChangeTelephoneHandler(e.target.value)
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className={"pre_order_fields_wrapper"}>
                                                <span>Email *</span>
                                                <input
                                                    onChange={(e) =>
                                                        userPreOrderChangeEmailHandler(e.target.value)
                                                    }
                                                    value={
                                                        userPreOrderFields.email
                                                            ? userPreOrderFields.email
                                                            : ""
                                                    }
                                                    type="text"
                                                />
                                            </div>
                                        </div>
                                        <span className={"pre_order_finally_valid_text"}>
                                            {errorPreOrderText ? errorPreOrderText : ""}
                                        </span>
                                        <span
                                            onClick={(e) => onClickPreOrderButtonHandler()}
                                            className={"pre_order_finally_button"}
                                        >
                                            Оформить
                                        </span>
                                        <CheckBoxPolitic
                                            setStateCheсkBox={(e) => setStateCheсkBoxPreorder(e)}
                                            stateCheсkBox={stateCheсkBoxPreorder}
                                        />
                                    </div>
                                ) : (
                                    ""
                                )}

                                {!preOrderInfo && successState ? (
                                    <div className={"pre_order_success"}>
                                        <div className="order_notificator">
                                            <div className="circle_success"></div>
                                            <span className="thank_you_for_order">
                                                <noindex>Спасибо за заказ!</noindex>
                                            </span>
                                            <div className="thank_text_container">
                                                <span className="thank_text_child">
                                                    Ваш заказ успешно оформлен.{" "}
                                                </span>
                                                <span className="thank_text_child">
                                                    В ближайшее время с вами свяжется менеджер.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>

                    {settings.projectWidth && settings.projectWidth > 768 ? (
                        <ProductBreadcrumbs
                            params={breadcrumbsParams}
                            product_name={nameProduct}
                            parrent_url={parrent}
                            child_url={child}
                        />
                    ) : (
                        ""
                    )}

                    <div id={getOfferId()} className={"product_page_content_container"}>
                        {settings.projectWidth && settings.projectWidth < 1024 ? (
                            <div className={"back_button_product_wrapper"}>
                                <div
                                    onClick={(e) => handleClick()}
                                    className={"back_button_product"}
                                >
                                    <svg
                                        width="33"
                                        height="22"
                                        viewBox="0 0 55 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12 2L2 11.0454L12 20"
                                            stroke="black"
                                            strokeWidth="2"
                                            strokeLinecap="square"
                                        />
                                        <line
                                            x1="2"
                                            y1="11"
                                            x2="55"
                                            y2="11"
                                            stroke="black"
                                            strokeWidth="2"
                                        />
                                    </svg>
                                    <span>Назад</span>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}

                        <div className={"container_slider_sticky"}>
                            <div
                                onTouchStart={onTouchStart}
                                onTouchMove={onTouchMove}
                                onTouchEnd={onTouchEnd}
                                className={"product_page_first_image_container"}
                            >
                                <div
                                    className={"product_img_wrapper"}
                                    onClick={handleZoomClick}
                                >
                                    {activeChild.img_first ? (
                                        <div>
                                            {activLinkPhoto && activLinkPhoto !== "" ? (
                                                <img
                                                    itemProp="image"
                                                    id={"height_product_img"}
                                                    src={
                                                        process.env.REACT_APP_API_URL +
                                                        "uploads/images/" +
                                                        activeChild.productId +
                                                        "/" +
                                                        activeChild.id +
                                                        "/" +
                                                        "950_" +
                                                        activLinkPhoto
                                                    }
                                                    alt={
                                                        (nameProduct ? nameProduct : "") +
                                                        "; цвет: " +
                                                        (activeChild.color.color_name
                                                            ? activeChild.color.color_name
                                                            : "")
                                                    }
                                                />
                                            ) : (
                                                <img
                                                    itemProp="image"
                                                    id={"height_product_img"}
                                                    src={
                                                        activeChild.img_first !== null &&
                                                        activeChild.img_first !== ""
                                                            ? process.env.REACT_APP_API_URL +
                                                            "uploads/images/" +
                                                            activeChild.productId +
                                                            "/" +
                                                            activeChild.id +
                                                            "/" +
                                                            "950_" +
                                                            activeChild.img_first
                                                            : "/files/images/noimg.png"
                                                    }
                                                    alt={
                                                        (nameProduct ? nameProduct : "") +
                                                        "; цвет: " +
                                                        (activeChild.color.color_name
                                                            ? activeChild.color.color_name
                                                            : "")
                                                    }
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            {activLinkPhoto && activLinkPhoto !== "" ? (
                                                <img
                                                    itemProp="image"
                                                    id={"height_product_img"}
                                                    src={
                                                        process.env.REACT_APP_API_URL +
                                                        "uploads/images/" +
                                                        activeChild.productId +
                                                        "/" +
                                                        activeChild.id +
                                                        "/" +
                                                        "950_" +
                                                        activLinkPhoto
                                                    }
                                                    alt={
                                                        (nameProduct ? nameProduct : "") +
                                                        "; цвет: " +
                                                        (activeChild.color.color_name
                                                            ? activeChild.color.color_name
                                                            : "")
                                                    }
                                                />
                                            ) : (
                                                <img
                                                    itemProp="image"
                                                    id={"height_product_img"}
                                                    src={
                                                        activeChild.img_preview !== null &&
                                                        activeChild.img_preview !== ""
                                                            ? process.env.REACT_APP_API_URL +
                                                            "uploads/images/" +
                                                            activeChild.productId +
                                                            "/" +
                                                            activeChild.id +
                                                            "/" +
                                                            "950_" +
                                                            activeChild.img_preview
                                                            : "/files/images/noimg.png"
                                                    }
                                                    alt={
                                                        (nameProduct ? nameProduct : "") +
                                                        "; цвет: " +
                                                        (activeChild.color.color_name
                                                            ? activeChild.color.color_name
                                                            : "")
                                                    }
                                                />
                                            )}
                                        </div>
                                    )}

                                    <div className={"product_page_like_wrapper"}>
                                        <Like
                                            onAddInFavorite={() =>
                                                pushGoogleAnalyticProductAction("add_to_wishlist", [
                                                    activeChild,
                                                ])
                                            }
                                            itemProduct={{
                                                ...parent,
                                                id: activeChild.id,
                                                color: activeChild.color,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className={"product_img_array"}
                            >
                                {imgProduct
                                    ? imgProduct.map((item, index) => (
                                        <div
                                            onClick={(e) => {
                                                setActivLinkPhoto(item.linkImg);
                                                setGalleryModal({
                                                    ...galleryModal,
                                                    index: index,
                                                });
                                            }}
                                            key={index}
                                            className={
                                                activLinkPhoto === item.linkImg
                                                    ? "one_img_product active"
                                                    : "one_img_product"
                                            }
                                        >
                                            <img
                                                src={
                                                    process.env.REACT_APP_API_URL +
                                                    "uploads/images/" +
                                                    activeChild.productId +
                                                    "/" +
                                                    activeChild.id +
                                                    "/" +
                                                    "950_" +
                                                    item.linkImg
                                                }
                                                alt={
                                                    (nameProduct ? nameProduct : "") +
                                                    "; цвет: " +
                                                    (activeChild.color.color_name
                                                        ? activeChild.color.color_name
                                                        : "")
                                                }
                                            />
                                        </div>
                                    ))
                                    : ""}
                            </div>
                        </div>

                        <div className={"product_page_right_content_container"}>
                            <h1>
                                <div className={"product_page_h1_container"}>
                                    <div className={"page_product_heading"}>
                                        {nameProduct ? nameProduct + " " : ""}
                                    </div>
                                </div>
                                <div className={"page_product_atricul"}>
                                    <span>Артикул: {" " + oneProduct.articul}</span>
                                </div>
                            </h1>
                            {!activeChild.price_hidden ? (
                                <div className={"price_and_shares"}>
                                    <div className={"one_product_page_price_line"}>
                                        <span className={"one_product_page_price"}>
                                            {activeChild.sell_price
                                                ? priceToUserString(activeChild.sell_price) + " ₽"
                                                : ""}
                                        </span>{" "}
                                        <span
                                            className={
                                                activeChild.sell_price
                                                    ? "standard_price old_price"
                                                    : "standard_price"
                                            }
                                        >
                                            {priceToUserString(oneProduct.price) + " ₽"}
                                        </span>
                                    </div>
                                    {
                                        <>
                                            <div className={"installment_wrapper"}>
                                                <img style={{marginRight: "5px"}} src={"/files/images/payments/ysplit.svg"}></img>
                                                <a
                                                    href={"/shares/"}
                                                    target={"_blank"}
                                                    rel="noreferrer"
                                                    className={"installment_child"}
                                                >
                                                    <svg
                                                        width="120"
                                                        height="35"
                                                        viewBox="0 0 68 21"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <rect
                                                            y="0.5"
                                                            width="68"
                                                            height="20"
                                                            rx="4"
                                                            fill="black"
                                                        />
                                                        <g clip-path="url(#clip0_30955_166)">
                                                            <path
                                                                d="M15.9392 6.5H14.6044V13.2689H15.9392V6.5Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M13.0711 6.87876H11.7363V13.6475H13.0711V6.87876Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M10.203 7.30162H8.86814V14.0716H10.203V7.30162Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M7.33482 7.72917H6L6.00001 14.5H7.33482L7.33482 7.72917Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M51.194 10.1063L49.0447 7.71671H47.7882V13.2495H49.1001V9.71946L51.0623 11.8109H51.3047L53.2332 9.71946V13.2495H54.5451V7.71671H53.2886L51.194 10.1063Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M60.795 7.71671L57.5435 11.3128V7.71671H56.2316V13.2495H57.4335L60.685 9.65338V13.2495H61.9969V7.71671H60.795Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M40.7222 9.74122C40.7222 10.6221 41.2039 11.316 41.9433 11.607L40.5568 13.2495H42.1625L43.4238 11.7553H44.7886V13.2495H46.1005V7.71671H42.7606C41.5154 7.71671 40.7222 8.56858 40.7222 9.74122ZM44.7895 8.93528V10.5713H43.0039C42.4082 10.5713 42.0886 10.2393 42.0886 9.75251C42.0886 9.26572 42.4194 8.93367 43.0039 8.93367L44.7895 8.93528Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M34.626 8.82326C34.5457 10.7261 34.1443 11.9543 33.3583 11.9543H33.1616V13.2825L33.3712 13.2938C34.9472 13.3817 35.8183 11.9987 35.9612 8.978H38.0341V13.2495H39.3436V7.71671H34.6702L34.626 8.82326Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M29.6877 7.6394C27.9134 7.6394 26.6369 8.86765 26.6369 10.4828C26.6369 12.1535 28.0258 13.3382 29.6877 13.3382C31.4187 13.3382 32.7635 12.0874 32.7635 10.4828C32.7635 8.87813 31.4187 7.6394 29.6877 7.6394ZM29.6877 12.01C28.685 12.01 28.0017 11.3572 28.0017 10.4828C28.0017 9.58655 28.6858 8.95147 29.6877 8.95147C30.6897 8.95147 31.3962 9.61557 31.3962 10.4828C31.3962 11.3499 30.6801 12.01 29.6877 12.01Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                d="M25.2456 7.72714H20.6155L20.5713 8.8337C20.5055 10.4278 20.0896 11.9438 19.3036 11.9656L18.9399 11.9769V14.5L20.263 14.4974V13.2502H24.8594V14.4974H26.1937V11.9656H25.2456V7.72714ZM23.9337 11.9656H21.1341C21.6078 11.2467 21.8615 10.2062 21.9057 8.98924H23.9337V11.9656Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_30955_166">
                                                                <rect
                                                                    width="56"
                                                                    height="8"
                                                                    fill="white"
                                                                    transform="translate(6 6.5)"
                                                                />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </a>
                                                <div className={"installment_child"}>
                                                    <span className={"installment_text"}>
                                                        4 платежа по{" "}
                                                    </span>
                                                    <span className={"installment_price"}>
                                                        {activeChild.sell_price
                                                            ? activeChild.sell_price / 4 + " ₽"
                                                            : oneProduct.price / 4 + " ₽"}
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {/* <div className={"one_product_ysplit_action"}>Акция! 6 месяцев без переплат!</div> */}
                                </div>
                            ) : (
                                ""
                            )}

                            <div className={"one_page_content_selectors_container"}>
                                {
                                    <div className={"page_product_color_changer_wrapper"}>
                                        {activeChild.color ? (
                                            <div>
                                                <span className={"page_product_name_field"}>
                                                    Цвет:{" "}
                                                </span>{" "}
                                                {activeChild.color.color_name}
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {
                                            <div className="page_product_color_changer">
                                                {oneProduct.childProducts
                                                    ? oneProduct.childProducts.filter(item => !isEnforced ||
                                                        (item.is_active === true && item.product?.active_product === true)).map((item, index) => {
                                                        return (
                                                            <div
                                                                key={index}
                                                                onClick={(e) =>
                                                                    changeActiveProductToColor(item)
                                                                }
                                                                className={
                                                                    activeChild.colorId === item.color.id
                                                                        ? "one_product_color_wrapper active"
                                                                        : "one_product_color_wrapper"
                                                                }
                                                            >
                                                                <div
                                                                    style={
                                                                        item.color.img
                                                                            ? {
                                                                                backgroundImage:
                                                                                    "url(" +
                                                                                    process.env.REACT_APP_API_URL +
                                                                                    "uploads/images/colors/" +
                                                                                    item.color.id +
                                                                                    "/" +
                                                                                    item.color.img +
                                                                                    ")",
                                                                            }
                                                                            : { backgroundColor: item.color.hex }
                                                                    }
                                                                    key={item.id}
                                                                    className={
                                                                        item.color.hex === "white" ||
                                                                        item.color.hex == "#ffffff"
                                                                            ? "product_page_color_circle active"
                                                                            : "product_page_color_circle"
                                                                    }
                                                                ></div>
                                                            </div>
                                                        );
                                                    })
                                                    : ""}
                                            </div>
                                        }
                                    </div>
                                }

                                <div className={"page_product_size_wrapper"}>
                                    {
                                        <>
                                            <div className={"page_product_size_name_line"}>
                                                <span className={"page_product_size_name"}>
                                                    Размер:{" "}
                                                </span>
                                            </div>
                                            <div className={"page_product_sizes_container"}>
                                                {activeChild
                                                    ? readDisplayRows(activeChild.child_product_size_field, 256).map(
                                                        (item, index) => {
                                                            if (item.isActive === true) {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        onClick={(e) =>
                                                                            changeSizeChildProduct(item)
                                                                        }
                                                                        className={getClassForSize(item)}
                                                                    >
                                                                        {item.size_name}
                                                                    </div>
                                                                );
                                                            }
                                                        }
                                                    )
                                                    : ""}
                                            </div>
                                        </>
                                    }

                                    {activeChild.product.electron_sertificate === true && isEnforced &&
                                    sizeCommerce.action !== 'certificate' ? (
                                        <span className="product_page_add_to_basket disactive">Сертификат временно недоступен</span>
                                    ) : activeChild.product.electron_sertificate === true &&
                                    (!isEnforced || sizeCommerce.action === 'certificate') ? (
                                        <span
                                            className={"product_page_add_to_basket sertificat"}
                                            onClick={(e) => {
                                                if (!usesEnforcedCommerce(activeChild) ||
                                                    getSizeCommerceView(activeChild, activeSizeChildProduct).action === 'certificate') {
                                                    wiewSertificateModal();
                                                }
                                            }}
                                        >
                                            Купить сертификат
                                        </span>
                                    ) : (
                                        <div>
                                            {draftCandidate ? <>
                                                <div className="product_page_controll_buttons_offer_and_basket">
                                                    <button type="button" className="product_page_add_to_basket" onClick={addSelectedPreorder}>
                                                        Оформить предзаказ
                                                    </button>
                                                </div>
                                                {draftError && <p role="alert">{draftError}</p>}
                                            </> : quoteCandidate ? user.isAuth ? (
                                                <button type="button" className="product_page_add_to_basket" onClick={() => setOpenQuoteKey(quoteKey)}>
                                                    Рассчитать предзаказ
                                                </button>
                                            ) : <p>Войдите в аккаунт, чтобы рассчитать предзаказ.</p>
                                            : purchaseAvailable ? (
                                                <div className="product_page_controll_buttons_offer_and_basket">
                                                    <span className={activeSizeChildProduct && canAddSelected
                                                        ? "product_page_add_to_basket"
                                                        : "product_page_add_to_basket disactive"}
                                                        onClick={() => {
                                                            const added = addToBasketHandlerProductPage(activeChild, activeSizeChildProduct);
                                                            if (added && window && window._txq) window._txq.push(['track', 'korzina']);
                                                        }}>
                                                        Добавить в корзину
                                                    </span>
                                                    {showOneClickButton && canAddSelected ? <span
                                                        onClick={() => addToFieldsProductModal(activeChild, activeSizeChildProduct, true)}
                                                        className="product_page_go_offer">Купить в 1 клик</span> : ""}
                                                </div>
                                            ) : (
                                                <div className="product_page_controll_buttons_offer_and_basket">
                                                    <span className="product_page_add_to_basket disactive">Оформить предзаказ</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className={"description_product_wrapper"}>
                                    {oneProduct && oneProduct.description_product_content ? (
                                        <div
                                            className={
                                                descriptionState
                                                    ? "product_page_shield_child_product active"
                                                    : "product_page_shield_child_product"
                                            }
                                        >
                                            <div
                                                onClick={(e) => setDescriptionState(!descriptionState)}
                                                className={"product_page_shield_name"}
                                            >
                                                <span>Детали</span>{" "}
                                                <span className={"arrow_to_controll_shield"}></span>
                                            </div>
                                            <div className={"product_page_child_items_container"}>
                                                <div
                                                   
                                                    className={"product_page_description_product_text"}
                                                >
                                                    {oneProduct.description_product_content}
                                                </div>
                                                {oneProduct.description_product_content.toLowerCase().includes('параметры модели') && <p>*Обратите внимание, что размеры могут отличаться, в зависимости от кроя и особенностей ткани.</p>
                                                }
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}

                                    {sostavContent[0] ? (
                                        <div
                                            className={
                                                sostavState
                                                    ? "product_page_shield_child_product active"
                                                    : "product_page_shield_child_product"
                                            }
                                        >
                                            <div
                                                onClick={(e) => setSostavState(!sostavState)}
                                                className={"product_page_shield_name"}
                                            >
                                                <span>Состав</span>{" "}
                                                <span className={"arrow_to_controll_shield"}></span>
                                            </div>

                                            <div className={"product_page_child_items_container"}>
                                                <div className={"product_page_wrapper_for_sostav"}>
                                                    {sostavContent.map((item, index) => {
                                                        return (
                                                            <div
                                                                className={"product_page_one_sostav"}
                                                                key={index}
                                                            >
                                                                <span key={index}>{item.name_sost}</span>
                                                                {item.fields
                                                                    ? item.fields.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>{item.value}</span>
                                                                        );
                                                                    })
                                                                    : ""}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            <div className={"product_page_child_items_container"}>
                                                <div className={"product_page_landrys_wrapper"}>
                                                    {oneProduct.landry_product_table
                                                        ? oneProduct.landry_product_table.map(
                                                            (item, index) => {
                                                                return (
                                                                    <div
                                                                        onClick={(e) =>
                                                                            stateCareSwitch(item, index)
                                                                        }
                                                                        key={index}
                                                                        className={
                                                                            activeCareIcons === index
                                                                                ? "product_page_one_landry active"
                                                                                : "product_page_one_landry"
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                process.env.REACT_APP_API_URL +
                                                                                "uploads/images/landry/" +
                                                                                item.id +
                                                                                "/" +
                                                                                item.img
                                                                            }
                                                                            alt="YouWanna - уход"
                                                                        />
                                                                    </div>
                                                                );
                                                            }
                                                        )
                                                        : ""}
                                                </div>
                                                <div className={"product_page_one_landry_text"}>
                                                    {careSwitch}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}

                                    {allObmerContent ? (
                                        <div
                                            className={
                                                obmerState
                                                    ? "product_page_shield_child_product active"
                                                    : "product_page_shield_child_product"
                                            }
                                        >
                                            <div
                                                onClick={(e) => setObmerState(!obmerState)}
                                                className={"product_page_shield_name"}
                                            >
                                                <span>Таблица размеров</span>{" "}
                                                <span className={"arrow_to_controll_shield"}></span>
                                            </div>
                                            <div className={"product_page_child_items_container"}>
                                                <div className={"obmer_wrapper_product_page"}>
                                                    <div className={"product_page_size_items"}>
                                                        <div className={"product_page_obmer_text"}>
                                                            Посмотреть обмеры размера:
                                                        </div>
                                                        <div className={"product_page_size_list"}>
                                                            {obmerContent.map((item, index) => {
                                                                return (
                                                                    <div className={"one_column_obmer"}>
                                                                        <div
                                                                            key={index}
                                                                            className={
                                                                                item.size_name_obmer === activeObmerName
                                                                                    ? "product_page_size_button active"
                                                                                    : "product_page_size_button"
                                                                            }
                                                                            // className={"product_page_size_button"}
                                                                            onClick={(e) =>
                                                                                setActiveObmerName(item.size_name_obmer)
                                                                            }
                                                                        >
                                                                            {item.size_name_obmer}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>

                                                    <div className={"content_selection_size"}>
                                                        {getCurrentObmerToSizeName().fields
                                                            ? getCurrentObmerToSizeName().fields.map(
                                                                (item, index) => {
                                                                    return (
                                                                        <div
                                                                            key={index}
                                                                            className={
                                                                                "product_page_obmer_size_params"
                                                                            }
                                                                        >
                                                                            <div>{item.name}</div>
                                                                            <div
                                                                                className={"to_bottom_border_obmer"}
                                                                            ></div>
                                                                            <div>{item.value}</div>
                                                                        </div>
                                                                    );
                                                                }
                                                            )
                                                            : ""}
                                                        <div className={"description_size_model"}>
                                                            {allObmerContent.sizeModel
                                                                ? allObmerContent.sizeModel
                                                                : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}

                                    { currentStock  && (
                                        <div
                                            className={
                                                stockState
                                                    ? "product_page_shield_child_product active"
                                                    : "product_page_shield_child_product"
                                            }
                                        >
                                            <div
                                                onClick={(e) => setStockState(!stockState)}
                                                className={"product_page_shield_name"}
                                            >
                                                <span>Наличие в магазинах</span>{" "}
                                                <span className={"arrow_to_controll_shield"}></span>
                                            </div>
                                            <div className={"product_page_child_items_container"}>
                                                <div className={"obmer_wrapper_product_page"}>
                                                    <div className={"product_page_size_items"}>
                                                        <table className={"product_stock_table"}>
                                                            {
                                                                currentStock.map(
                                                                    (item, index) => {
                                                                        if (index === 0) {
                                                                            return (
                                                                                <thead>
                                                                                {item.map( name => {
                                                                                    return (<th>{name}</th>)
                                                                                })}
                                                                                </thead>
                                                                            );
                                                                        }
                                                                    }
                                                                )
                                                            }

                                                            <tbody>

                                                            {
                                                                currentStock.map(
                                                                    (item, index) => {
                                                                        if (index > 0) {
                                                                            return (
                                                                                <tr>
                                                                                    {item.map( stock => {
                                                                                        if(item[0].stock.code !== 'f8bbc32b-8b9e-11ee-80c1-fa163e0fa166'){
                                                                                            if(stock?.stock ){
                                                                                                return (<td>
                                                                                                    {stock.stock.name}
                                                                                                    {
                                                                                                        stock.stock.market ?
                                                                                                            <div className={'stockDetail hidden'}>
                                                                                                                <div className={'stockDetail_info '}>
                                                                                                                    <p className={"stockDetail_info--name"}>Адрес:</p>
                                                                                                                    <p className={"stockDetail_info--detail"}>{stock.stock.market.address}</p>
                                                                                                                    <p className={"stockDetail_info--name"}>Телефон:</p>
                                                                                                                    <a className={"stockDetail_info--detail"} href={'tel:'+stock.stock.market.front_number.replace(/([\s-])?([(])?([)])?/gm, "") }>{stock.stock.market.front_number}</a>
                                                                                                                </div>
                                                                                                                <span className={"stockDetail_info--toogler"} onClick={toogleStockDetail} ></span>
                                                                                                            </div> : ""
                                                                                                    }
                                                                                                </td>)
                                                                                            } else {
                                                                                                if(stock === true) {
                                                                                                    return (
                                                                                                        <td>
                                                                                                            <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M4.84001 9.1899L1.34001 5.6899L0.17334 6.85657L4.84001 11.5232L14.84 1.52323L13.6733 0.356567L4.84001 9.1899Z" fill="black"/>
                                                                                                            </svg>
                                                                                                        </td>
                                                                                                    )
                                                                                                } else {
                                                                                                    return (
                                                                                                        <td aria-label={stock === null ? 'Наличие не подтверждено' : undefined}>
                                                                                                            <svg width="13" height="3" viewBox="0 0 13 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M12.1733 2.52323H0.506592V0.856567H12.1733V2.52323Z" fill="#323232"/>
                                                                                                            </svg>
                                                                                                        </td>
                                                                                                    )
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    })}
                                                                                </tr>
                                                                            );
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                            </tbody>
                                                        </table>
                                                        <p class={"product_stock_warning"}>Просьба предварительно сделать звонок для подтверждения наличия товара в магазине*</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )}

                                    {deliveryContent && (
                                        <div
                                            className={
                                                deliveryState
                                                    ? "product_page_shield_child_product active"
                                                    : "product_page_shield_child_product"
                                            }
                                        >
                                            <div
                                                onClick={(e) => setDeliveryState(!deliveryState)}
                                                className={"product_page_shield_name"}
                                            >
                                                <span>Варианты доставки</span>{" "}
                                                <span className={"arrow_to_controll_shield"}></span>
                                            </div>
                                            <div className={"product_page_child_items_container"}>
                                                <div
                                                    className={"product_page_description_product_text"}
                                                >
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: deliveryContent,
                                                        }}
                                                    ></span>
                                                </div>
                                                <Link className={"link"} to="/about/delivery">
                                                    Подробнее об условиях доствки
                                                </Link>
                                            </div>
                                        </div>
                                    )}

                                    <div
                                        className={
                                            callbackState
                                                ? "product_page_shield_child_product active"
                                                : "product_page_shield_child_product"
                                        }
                                    >
                                        <div
                                            onClick={(e) => setCallbackState(!callbackState)}
                                            className={"product_page_shield_name"}
                                        >
                                            <span>Задать вопрос</span>{" "}
                                            <span className={"arrow_to_controll_shield"}></span>
                                        </div>
                                        <div className={"product_page_child_items_container"}>
                                            <div className={"wrapper_call_container"}>
                                                <a
                                                    href={"tel:+79268877007"}
                                                    target={"blank"}
                                                    className={"one_call_element_wrapper"}
                                                >
                                                    <img
                                                        className={"icon_for_call"}
                                                        src="/files/images/call_phone.jpg"
                                                        alt=""
                                                    />
                                                </a>
                                                <a
                                                    className={"one_call_element_wrapper"}
                                                    href={
                                                        "https://api.whatsapp.com/send/?phone=79268877007&text=Здравствуйте%2C+меня+интересует " +
                                                        window.location.href
                                                    }
                                                    target={"blank"}
                                                >
                                                    <img
                                                        className={"icon_for_call"}
                                                        src="/files/images/whats.png"
                                                        alt=""
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {activeSliderComponents ? (
                        <div className={"slider_product_wrapper"}>
                            <div
                                className={
                                    productComplects && productRecomendation
                                        ? "switch_slider active"
                                        : "title_slider"
                                }
                            >
                                {productComplects && productComplects !== "" ? (
                                    <div
                                        onClick={(e) => setStateSwitchSlider("image")}
                                        className={
                                            stateSwitchSlider === "image"
                                                ? "title_image active"
                                                : "title_image"
                                        }
                                    >
                                        <span> Купить образ</span>
                                        <div className={"title_image_switch"}></div>
                                    </div>
                                ) : (
                                    ""
                                )}
                                {productRecomendation && productRecomendation !== "" ? (
                                    <div
                                        onClick={(e) => setStateSwitchSlider("like")}
                                        className={
                                            stateSwitchSlider === "like"
                                                ? "title_like active"
                                                : "title_like"
                                        }
                                    >
                                        <span>Вам также может понравиться</span>
                                        <div className={"title_like_switch"}></div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                            {stateSwitchSlider === "image" ? (
                                <OfferSliderProduct
                                    productMokTest={productComplects}
                                    parrent={parrent}
                                    child={child}
                                />
                            ) : (
                                <OfferSliderProduct
                                    productMokTest={productRecomendation}
                                    parrent={parrent}
                                    child={child}
                                />
                            )}
                        </div>
                    ) : (
                        ""
                    )}
                    {
                        lastViewed.length ?
                            <div className={"slider_product_wrapper"}>
                                <div className={"title_slider"}>
                                    <div className={"title_like active"}>
                                        <span>Вы недавно смотрели</span>
                                        <div className={"title_like_switch"}></div>
                                    </div>
                                </div>
                                <OfferSliderProduct
                                    productMokTest={lastViewed}
                                    parrent={parrent}
                                    child={child}
                                />
                            </div>
                            : ''
                    }
                </div>
            ) : (
                <Spiner />
            )}

            {galleryModal.isActive && (
                <Modal
                    onClose={handleProductModalClose}
                    modalOverlayClassName="product-modal__overlay"
                    extraClass="product-modal__window"
                >
                    <div className="product-modal__wrapper" ref={productModalRef}>
                        <button
                            className="product-modal__close"
                            onClick={handleProductModalClose}
                            style={{
                                right: productModalScrollWidth + "px"
                            }}
                        >
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeWidth="1px"
                                    vector-effect="non-scaling-stroke"
                                    stroke="currentColor"
                                    d="M5 5L12 12M12 12L19 19M12 12L5 19M12 12L19 5"
                                ></path>
                            </svg>
                        </button>
                        <Swiper
                            loop
                            navigation={{
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            }}
                            centeredSlides={true}
                            initialSlide={galleryModal.index}
                        >
                            <span slot="container-start">
                                <div className="product-modal__navigation">
                                    <div class="swiper-button-prev"></div>
                                    <div class="swiper-button-next" style={{
                                        paddingRight: productModalScrollWidth + "px"
                                    }}></div>
                                </div>
                            </span>
                            {imgProduct &&
                                imgProduct.length &&
                                imgProduct.map((item, index) => (
                                    <SwiperSlide>
                                        <img
                                            className="product-modal__img"
                                            src={
                                                process.env.REACT_APP_API_URL +
                                                "uploads/images/" +
                                                activeChild.productId +
                                                "/" +
                                                activeChild.id +
                                                "/" +
                                                "950_" +
                                                item.linkImg
                                            }
                                            width={950}
                                            height={1425}
                                            alt={
                                                (nameProduct ? nameProduct : "") +
                                                "; цвет: " +
                                                (activeChild.color.color_name
                                                    ? activeChild.color.color_name
                                                    : "")
                                            }
                                        />
                                    </SwiperSlide>
                                ))}
                        </Swiper>
                    </div>
                </Modal>
            )}
        </div>
    );
});

export default OneProductPage;
